var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showpop,
          expression: "showpop",
        },
      ],
      staticClass: "maskTips",
    },
    [
      _vm.iscopy
        ? _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0, 0.4)",
              },
            },
            [
              _c("iframe", {
                ref: "mainIframe",
                staticStyle: {
                  width: "100%",
                  height: "100%",
                  "overflow-x": "hidden",
                  border: "0px",
                  "margin-top": "-20px",
                },
                attrs: {
                  src: "./pricing.html",
                  id: "mainIframe",
                  name: "mainIframe",
                },
              }),
            ]
          )
        : _c(
            "div",
            {
              staticStyle: {
                padding: "0px 0px 40px 0",
                "max-width": "1400px",
                "border-radius": "16px",
              },
            },
            [
              _c("div", { staticClass: "maskRights" }, [
                _c("div", { staticClass: "buySuccess" }, [
                  _c("i", { staticClass: "close" }),
                  _c("div", [
                    _c("img", {
                      attrs: {
                        src: require("../assets/success.svg"),
                        alt: "Success",
                      },
                    }),
                    _c("p", { staticClass: "info Member" }, [
                      _vm._v(_vm._s(_vm.$t("return_home"))),
                    ]),
                    _c("p", { staticClass: "info noMember" }, [
                      _vm._v(_vm._s(_vm.$t("congratulations"))),
                      _c("span", { staticClass: "loginMaskbtn" }, [
                        _vm._v(_vm._s(_vm.$t("login_benefits"))),
                      ]),
                      _vm._v(_vm._s(_vm.$t("no_registered"))),
                      _c("span", { staticClass: "registerMaskbtn" }, [
                        _vm._v(_vm._s(_vm.$t("register_account"))),
                      ]),
                      _vm._v(_vm._s(_vm.$t("other_accounts"))),
                    ]),
                    _c("span", { staticClass: "btn" }, [
                      _vm._v(_vm._s(_vm.$t("btn_close"))),
                    ]),
                  ]),
                ]),
              ]),
              _c("i", { staticClass: "close", on: { click: _vm.closePop } }),
              _c("div", { staticClass: "buy" }, [
                _c("div", { staticClass: "container" }, [
                  _c("h1", [_vm._v(_vm._s(_vm.$t("pricing.h1")))]),
                  _c("p", [_vm._v(_vm._s(_vm.$t("pricing.banner_content")))]),
                  _c("div", { staticClass: "buy_box flex_box" }, [
                    _c("div", { staticClass: "best" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("pricing.best_seller"))),
                      ]),
                      _c("p", { staticClass: "title" }, [
                        _c("i"),
                        _vm._v(_vm._s(_vm.$t("pricing.monthly"))),
                      ]),
                      _c("p", { staticClass: "price" }, [
                        _vm._v(
                          _vm._s(_vm.pricing.symbol) +
                            _vm._s(_vm.showMonthPrice)
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "credits" },
                        _vm._l(_vm.monthInfo, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              class: { active: _vm.activeMonthly == index },
                              attrs: { plan: index },
                              on: {
                                click: function ($event) {
                                  return _vm.selectMonthly(index)
                                },
                              },
                            },
                            [
                              _c("i"),
                              _c("span", [
                                _vm._v(
                                  _vm._s(item.credits) +
                                    " " +
                                    _vm._s(_vm.$t("pricing.credits")) +
                                    " "
                                ),
                                item.off
                                  ? _c("span", { staticClass: "off" }, [
                                      _vm._v(_vm._s(item.off) + " OFF"),
                                    ])
                                  : _vm._e(),
                              ]),
                              _c("span", { staticClass: "price" }, [
                                _vm._v(
                                  _vm._s(_vm.pricing.symbol) +
                                    _vm._s(item.discount_price)
                                ),
                              ]),
                              _c("del", [
                                _vm._v(
                                  _vm._s(_vm.pricing.symbol) +
                                    _vm._s(item.original_price)
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "btn account_buy",
                          attrs: {
                            plan: "46",
                            "data-account-productid": "179",
                          },
                        },
                        [
                          _c("span", [
                            _c("i"),
                            _vm._v(_vm._s(_vm.$t("pricing.buy_now"))),
                          ]),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "lifetime" }, [
                      _c("p", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("pricing.lifetime"))),
                      ]),
                      _c("p", { staticClass: "price" }, [
                        _vm._v(
                          _vm._s(_vm.pricing.symbol) +
                            _vm._s(_vm.showLifetimePrice)
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "credits" },
                        _vm._l(_vm.lifetimeInfo, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              class: { active: _vm.activeLifetime == index },
                              attrs: { plan: index },
                              on: {
                                click: function ($event) {
                                  return _vm.selectLifetime(index)
                                },
                              },
                            },
                            [
                              _c("i"),
                              _c("span", [
                                _vm._v(
                                  _vm._s(item.credits) +
                                    " " +
                                    _vm._s(_vm.$t("pricing.credits"))
                                ),
                              ]),
                              _c("span", { staticClass: "price" }, [
                                _vm._v(
                                  _vm._s(_vm.pricing.symbol) +
                                    _vm._s(item.discount_price)
                                ),
                              ]),
                              _c("del", [
                                _vm._v(
                                  _vm._s(_vm.pricing.symbol) +
                                    _vm._s(item.original_price)
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "btn account_buy",
                          attrs: {
                            plan: "50",
                            "data-account-productid": "179",
                          },
                        },
                        [
                          _c("span", [
                            _c("i"),
                            _vm._v(_vm._s(_vm.$t("pricing.buy_now"))),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _c("p", { staticClass: "note_tips" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("pricing.note")))]),
                _vm._v(": " + _vm._s(_vm.$t("pricing.note_content"))),
              ]),
            ]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }